import styled from 'styled-components';

export const Container = styled.div`
  form {
    width: 100%;

    label[for='code_order_recharge'] {
      font-size: 18px;
    }

    .buttonsContainer {
      display: flex;
      justify-content: flex-end;
    }
    .async-text {
      margin-bottom: 10px;
    }
  }
`;
